import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.shouldShow)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        title: _ctx.tooltip,
        class: "has_tooltip",
        "data-viewport": "#section-content",
        "data-placement": "right"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.iconStatus.color)
        }, [
          (_ctx.notext)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["glyphicon", _ctx.icon || _ctx.iconStatus.icon])
              }, null, 2))
            : _createCommentVNode("", true),
          (!_ctx.notext)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.textOutput), 1))
            : _createCommentVNode("", true)
        ], 2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}